const Wishlist = {
  key: "wishlist",

  get() {
    try {
      return JSON.parse(localStorage.getItem(this.key)) || [];
    } catch {
      return [];
    }
  },

  save(items) {
    localStorage.setItem(this.key, JSON.stringify([...new Set(items)]));
  },

  toggle(handle) {
    if (!handle) return;

    let items = this.get();

    if (items.includes(handle)) {
      items = items.filter(item => item !== handle);
    } else {
      items.push(handle);
    }

    this.save(items);
    this.updateButtons();
    this.updateCount();
  },

  updateButtons() {
    const items = this.get();

    document.querySelectorAll("[data-wishlist-button]").forEach(button => {
      const handle = button.dataset.productHandle;

      if (items.includes(handle)) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
      }
    });
  },

  updateCount() {
    const items = this.get();

    document.querySelectorAll("[data-wishlist-count]").forEach(count => {
      count.textContent = items.length;
      count.style.display = items.length > 0 ? "block" : "none";
    });
  },

  init() {
    document.addEventListener("click", e => {
      const button = e.target.closest("[data-wishlist-button]");
      if (!button) return;

      e.preventDefault();
      e.stopPropagation();

      this.toggle(button.dataset.productHandle);
    });

    this.updateButtons();
    this.updateCount();
  }
};

document.addEventListener("DOMContentLoaded", () => Wishlist.init());